export default __webpack_public_path__ + "static/apple-touch-icon-e674624835363c2fda3f483b2aca2477.png";